module.exports = __webpack_public_path__ + "static/media/bize-sorun-image.c5ff239b.png";